module.exports = __webpack_public_path__ + "static/media/sidebar-case-selected.e12174b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-case-selected.svg
// module id = 796
// module chunks = 0